<template>
  <div class="section mb-3">
    <h4 class="section-title">
      <font-awesome-icon :icon="['fas', 'screwdriver-wrench']" /> Consumibles y Recursos
    </h4>

    <!-- Checkbox para activar/desactivar la gestión de consumibles -->
    <div class="form-check mb-3">
      <input 
        type="checkbox" 
        class="form-check-input" 
        id="toggle-items" 
        v-model="mostrarFormulario" 
      />
      <label for="toggle-items" class="form-check-label">¿Agregar Consumibles y Recursos?</label>
    </div>

    <!-- Mostrar el formulario solo si se activa el checkbox -->
    <div v-if="mostrarFormulario">
      <!-- Selección de categoría de consumible -->
      <div class="row g-2 mb-3">
        <div class="col-md-6">
          <label for="categoria_item" class="form-label">Categoría del Consumible</label>
          <select
            id="categoria_item"
            class="form-select form-select-sm"
            v-model="selectedCategoriaInventario"
            @change="fetchItemsInventario"
          >
            <option value="">Seleccionar categoría</option>
            <option v-for="categoria in categoriasInventario" :key="categoria.id" :value="categoria.id">
              {{ categoria.id }} - {{ categoria.descripcion }}
            </option>
          </select>
        </div>

        <!-- Selección del ítem -->
        <div class="col-md-6">
          <label for="item-select" class="form-label">Seleccionar ítem</label>
          <select
            id="item-select"
            class="form-select form-select-sm"
            v-model="selectedItemInventario"
            @change="onItemChange"
          >
            <option value="">Seleccione un ítem</option>
            <option v-for="item in itemsInventario" :key="item.id" :value="item.id">
              {{ item.nombre }}
            </option>
          </select>
        </div>
      </div>

      <!-- Detalles del ítem seleccionado -->
      <div v-if="selectedItemInventario" class="mb-3">
        <div class="row g-2">
          <div class="col-md-6 d-flex align-items-center">
            <label class="form-check-label me-2">
              <input
                type="checkbox"
                class="form-check-input"
                v-model="descuentaStock"
              />
              Descontar del stock
            </label>
          </div>
          <div class="col-md-6">
            <label for="cantidad" class="form-label">Cantidad</label>
            <input
                type="number"
                id="cantidad"
                class="form-control form-control-sm"
                v-model="cantidad"
                :disabled="!descuentaStock"
                min="0"
                @input="onCantidadChange"
              />

            <div class="mt-1">
              <span v-if="cantidadActual" class="badge bg-warning me-2">Cantidad: {{ cantidadActual }}</span>
              <span v-if="unidadMedida" class="badge bg-info me-2">{{ unidadMedida }}</span>
              <span v-if="costo_unitario_usd" class="badge bg-success">Costo unitario: {{ costo_unitario_usd }}</span>
            </div>
            <div v-if="suma_del_costo" class="mt-1 text-primary">
              Suma del costo: {{ suma_del_costo }} $
            </div>
          </div>
        </div>

        <!-- Botón agregar ítem -->
        <div class="row mt-3">
          <div class="col text-end">
            <button class="btn btn-sm btn-primary" @click="agregarItem">Agregar Ítem</button>
          </div>
        </div>
      </div>

      <!-- Lista de ítems agregados -->
      <div v-if="itemsSeleccionados.length > 0" class="section mb-3">
        <h4 class="section-title">Items Agregados</h4>
        <span class="total-costo">Costo total aproximado: {{ sumatoriaCostoTotal }} $</span>
        <ul class="list-group">
          <li
            v-for="(item, index) in itemsSeleccionados"
            :key="index"
            class="list-group-item d-flex justify-content-between align-items-center"
          >
            {{ item.nombre }} - Cantidad: {{ item.cantidad }} {{ item.unidad_medida }} - Costo Total: {{ item.suma_del_costo }} $
            <button class="btn btn-sm btn-danger" @click="eliminarItem(index)">Eliminar</button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>
.total-costo {
  color: green;
  font-weight: bold;
  margin-left: 10px; /* Espacio entre el título y el subtítulo */
}
.section {
  border: 1px solid #e3e3e3;
  padding: 15px; /* Aumentar padding para mejor espaciado */
  border-radius: 8px;
  margin-bottom: 20px; /* Aumentar margen inferior */
  background-color: #f9f9f9; /* Fondo claro */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Añadir sombra para efecto de profundidad */
}

.section-title {
  margin-bottom: 15px; /* Aumentar espacio debajo del título */
  font-size: 1.25rem; /* Aumentar tamaño del título */
  color: var(--app-primary);
  font-weight: 600;
}

.form-label {
  margin-bottom: 0.5rem; /* Aumentar margen debajo de las etiquetas */
}

.form-select-sm, .form-control-sm {
  padding: 0.4rem 0.6rem; /* Ajustar padding de los inputs */
  font-size: 0.9rem; /* Ajustar tamaño del texto */
}

.badge {
  font-size: 0.8rem; /* Tamaño más pequeño para los badges */
}

.text-primary {
  font-size: 0.9rem;
  font-weight: 600;
}

.list-group-item {
  font-size: 0.95rem;
  padding: 0.6rem 0.8rem; /* Ajustar padding de los ítems en la lista */
  transition: background-color 0.3s ease; /* Transición para efecto hover */
}

.list-group-item:hover {
  background-color: #f1f1f1; /* Efecto hover para ítems de lista */
}

.btn {
  transition: background-color 0.3s ease, color 0.3s ease; /* Transición para botones */
}

.btn-primary:hover {
  background-color: #0056b3; /* Efecto hover para botón primario */
  color: #fff;
}

.btn-danger:hover {
  background-color: #c82333; /* Efecto hover para botón de eliminar */
  color: #fff;
}

@media (max-width: 768px) {
  .section {
    padding: 10px;
    margin-bottom: 15px;
  }
  .section-title {
    font-size: 1.1rem;
  }
  .form-label, .form-select-sm, .form-control-sm {
    font-size: 0.85rem;
  }
  .list-group-item {
    font-size: 0.9rem;
    padding: 0.5rem 0.7rem;
  }
  .btn {
    font-size: 0.85rem;
  }
}
</style>







  
<script>
import axios from '@/axios';

export default {
  props: {
    itemsSeleccionadosEdicion: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      mostrarFormulario: false, // Nuevo checkbox control
      selectedCategoriaInventario: '',
      selectedItemInventario: '',
      itemsSeleccionados: [...this.itemsSeleccionadosEdicion],
      cantidad: 0,
      descuentaStock: false,
      unidadMedida: '',
      cantidadActual: 0,
      costo_unitario_usd: 0,
      suma_del_costo: 0,
      sumatoriaCostoTotal: 0,

      categoriasInventario: [],
      itemsInventario: [],
    };
  },
  created() {
    this.cargarCategoriasConsumibles();
  },
  watch: {
    mostrarFormulario(newVal) {
      if (!newVal) {
        this.resetFormularioCompleto();
      }
    },
  },
  methods: {
    async cargarCategoriasConsumibles() {
      try {
        const response = await axios.get('/api/constantes/inventario_categorias');
        this.categoriasInventario = response.data;

        const respondeCategoriasActuales = await axios.get('/api/inventario_categorias', {
          params: { club_id: this.$store.getters.getClubActual.id },
        });
        const categoriasActuales = respondeCategoriasActuales.data;
        this.categoriasInventario = this.categoriasInventario.filter(categoria =>
          categoriasActuales.some(actual => actual === categoria.id)
        );

      } catch (error) {
        console.error('Error al cargar las categorías de consumibles:', error);
      }
    },
    async fetchItemsInventario() {
      if (!this.selectedCategoriaInventario) {
        this.itemsInventario = [];
        return;
      }
      try {

        const response = await axios.get(`/api/inventario_categoria/${this.selectedCategoriaInventario}`, {
          params: { club_id: this.$store.getters.getClubActual.id },
        });
        this.itemsInventario = response.data;

        
        this.selectedItemInventario = ''; // Limpiar el ítem seleccionado
      } catch (error) {
        console.error('Error al obtener ítems de la categoría seleccionada:', error);
      }
    },
    onItemChange() {
      const item = this.itemsInventario.find(i => i.id === this.selectedItemInventario);
      if (item) {
        this.unidadMedida = item.unidad_de_medida;
        this.cantidadActual = item.cantidad;
        this.costo_unitario_usd = item.costo_unitario_usd;
        this.suma_del_costo = this.cantidad * this.costo_unitario_usd;
      }
    },
    onCantidadChange() {
      this.suma_del_costo = this.cantidad * this.costo_unitario_usd;
    },
    agregarItem(event) {
      event.preventDefault();
      const item = this.itemsInventario.find(i => i.id === this.selectedItemInventario);
      if (item) {
        const nuevoItem = {
          id: item.id,
          nombre: item.nombre,
          cantidad: this.cantidad,
          unidad_medida: this.unidadMedida,
          descuenta_stock: this.descuentaStock,
          suma_del_costo: this.cantidad * this.costo_unitario_usd,
        };
        this.itemsSeleccionados.push(nuevoItem);
        this.sumatoriaCostoTotal += nuevoItem.suma_del_costo;
        this.$emit('actualizar-consumibles-recursos', this.itemsSeleccionados);

        // Reseteamos los campos después de agregar el ítem
        this.resetCampos();
      }
    },
    resetCampos() {
      this.selectedItemInventario = '';
      this.descuentaStock = false;
      this.cantidad = 0;
      this.unidadMedida = '';
      this.cantidadActual = 0;
      this.costo_unitario_usd = 0;
      this.suma_del_costo = 0;
    },
    resetFormularioCompleto() {
      this.selectedCategoriaInventario = '';
      this.itemsInventario = [];
      this.itemsSeleccionados = [];
      this.sumatoriaCostoTotal = 0;
      this.resetCampos();
      this.$emit('actualizar-consumibles-recursos', this.itemsSeleccionados);

    },
    eliminarItem(index) {
      this.sumatoriaCostoTotal -= this.itemsSeleccionados[index].suma_del_costo;
      this.itemsSeleccionados.splice(index, 1);
      this.$emit('actualizar-consumibles-recursos', this.itemsSeleccionados);
    },
  },
};
</script>

 